/* global performance */
import { getPrimaryUserRole } from '../../utils'
import { ANALYTICS_EVENTS } from '../utils'

export const getAppPerformanceTrackingHandler = ({ config, user, events }) => {
  const { APP_POST_LOGIN_READY } = ANALYTICS_EVENTS

  return {
    /**
     * Tracks the `app_post_login_ready` event.
     *
     * Reads the login timing globals set during the auth redirect, derives the
     * load duration and login type, and resets those globals so a later
     * session resume is measured correctly.
     *
     * @param {Object} data
     * @param {boolean} data.isInitialSyncFinished - true when this session
     *   performed a cold initial download for this user (at least one DB needed
     *   a first sync). This is per-user and per-DB, unlike the browser-global
     *   `initialSyncStatus` flag, so it correctly reports a heavy load for a
     *   user's first sync on a shared device.
     */
    postLoginReady: (data) => {
      const { isInitialSyncFinished } = data
      const startTime = window.__loginRedirectTime || window.__appLoadTime
      const loginType = window.__isFreshLogin ? 'fresh_login' : 'session_resume'
      window.__loginRedirectTime = null
      window.__isFreshLogin = false

      const duration = Math.round(performance.now() - startTime)
      const primaryRole = getPrimaryUserRole(user, config)

      events.track(APP_POST_LOGIN_READY, {
        duration_ms: duration,
        login_type: loginType,
        primary_role: primaryRole,
        is_first_sync: isInitialSyncFinished
      })
    }
  }
}
